<div #container>
  <app-badge variant="blue" class="cursor-pointer" title="Transfer Details">
    <span class="grid grid-cols-[auto_auto] gap-1 justify-items-center">
      <span>{{ data().total }}</span>
      <app-icons icon="arrow-left-arrow-right" svgClass=""/>
    </span>
  </app-badge>

  <app-tooltip [triggerEl]="container" triggerType="click" placement="left">
    <div class="text-left overflow-x-auto">
      <h5 class="text-lg font-bold dark:text-white">Transfer Details</h5>
      <table class="dark">
        <thead>
        <tr>
          <th>Location</th>
          <th>Qty</th>
          <th>Cost</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
          @for (source of data().sources; track $index) {
            <tr>
              <td>{{ source.name }}</td>
              <td class="text-right">{{ source.quantity }}</td>
              <td class="text-right">{{ source.cost | currency }}</td>
              <td class="text-right">{{ price()(source.cost) | currency }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </app-tooltip>
</div>
